import { styled } from '@mui/material/styles';

export const Title = styled('div')(({ theme }) => ({
	display: 'grid',
	width: '80%',
	...theme.typography.bodyTitle,
	color: theme.palette.primary.dark,
	marginTop: 14,
	marginBottom: 24,
}));

export const Text = styled('div')(({ theme }) => ({
	...theme.typography.body1,
	fontWeight: 600,
	color: theme.palette.primary.dark,
	marginTop: 12,
	marginBottom: 16,
}));

export const TripCardRoot = styled('div', {
	shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: string }>(({ theme, variant }) => ({
	backgroundColor: theme.palette.neutral[0],
	borderRadius: 8,
	padding: theme.spacing(1.5),
	border: '2px solid',
	borderLeft: '12px solid',

	borderColor:
		(variant === 'secondary_dark' && theme.palette.primary.dark) ||
		(variant === 'yellow' && theme.palette.additional.driverYellow) ||
		(variant === 'grey' && theme.palette.neutral[60]) ||
		(variant === 'blue' && theme.palette.primary.light) ||
		theme.palette.neutral[0],
}));

export const Row = styled('div', {
	shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant?: string }>(({ theme, variant }) => ({
	display: 'grid',
	/** Equal-width digits keep the time column aligned across rows and cards. */
	gridTemplateColumns: 'max-content 1fr',
	columnGap: theme.spacing(2),
	alignItems: 'start',
	fontVariantNumeric: 'tabular-nums',
	...theme.typography.body2,
	fontWeight: 600,
	color:
		variant === 'grey' ? theme.palette.neutral[60] : theme.palette.neutral[100],

	'&:not(:last-of-type)': {
		marginBottom: theme.spacing(2),
	},

	'#city': {
		...theme.typography.body2,
	},

	'& .deviatedTime': {
		display: 'block',
		color: theme.palette.warning.main,
	},

	'& .plannedTime': {
		display: 'block',
		textDecoration: 'line-through',
	},
}));
